import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addSubCrewsPersonel } from "../api/addSubCrewsPersonel";

export const useAddSubCrewsPersonel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => addSubCrewsPersonel(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["subCrewsPersonel"] });
    },
  });
};

